import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deletePickZone } from "@/api/pick-zones-api";

import { PICK_ZONES_QUERY_KEY } from "./use-pick-zones";

export const useDeletePickZone = (pickZoneId: string | undefined) => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, void>(
		{
			mutationFn: async () => {
				if (!pickZoneId) {
					throw new Error("Pick zone ID is required");
				}

				await deletePickZone(pickZoneId);

				await queryClient.refetchQueries({ queryKey: [PICK_ZONES_QUERY_KEY] });
			},
		},
		queryClient,
	);
};
